import {
  type BackupVault,
  Provider,
  ResourceType,
  type Snapshot,
  VaultStorageTier,
} from '@repo/api-gw-sdk';

export const COLD_TIER_SUPPORTED_RESOURCE_TYPES: ResourceType[] = [
  ResourceType.AwsS3,
];

// Cold-tier storage and restore are priced only for Eon-managed AWS vaults; the backend rejects any other vault.
export const isVaultSupportedForStorageTier = (
  vault: BackupVault,
  vaultStorageTier: VaultStorageTier
): boolean =>
  vaultStorageTier !== VaultStorageTier.VAULT_STORAGE_TIER_COLD ||
  (vault.vaultAttributes?.cloudProvider === Provider.Aws &&
    vault.isManagedByEon);

export const snapshotHasColdData = (snapshot: Snapshot): boolean =>
  (snapshot.coldFullSizeBytes ?? 0) > 0;

export const snapshotHasHotData = (snapshot: Snapshot): boolean =>
  (snapshot.fullSizeBytes ?? 0) > (snapshot.coldFullSizeBytes ?? 0);
